module.exports = __webpack_public_path__ + "static/img/pro1.810e88fd.png";